export class FloorOpsMetaData {
  primaryDepartmentId?: string;
  machineProficiencies: MachineProficiency[] = [];
}

export class MachineProficiency {
  machineId: string;
  level: number;
}
